export function makeRegionPreviewID(regionId: string) {
  return `region-preview-${regionId}`;
}

export function makePageThumbnailID(pageId: string) {
  return `page-thumbnail-${pageId}`;
}
